export const formatRule = (rule: string) =>
  rule
    .replace(/ /g, "<span class='markdown-space'>&lt;space&gt;</span>")
    .replace(/\n/g, "\\n")
    .replace(/\t/g, "\\t")
    .replace(/\r/g, "\\r");

export const escapeSearchQuery = (search: string) => search.replaceAll("\\", "\\\\");
